// WP-2.6 (AM-1..4, M24, S-06): web AI chat — text + push-to-talk voice capture, the same
// pipeline WhatsApp uses (AI-1). One-off actions (not cached queries), so both hooks are
// mutations; a successful capture invalidates the Inbox so the sidebar/bottom-nav badge and
// the Inbox list stay in sync with whatever this just created.
import {
  chatCaptureResponseSchema,
  chatVoiceCaptureResponseSchema,
  type ChatCaptureRequest,
  type ChatCaptureResponse,
  type ChatVoiceCaptureRequest,
  type ChatVoiceCaptureResponse,
} from '@pfos/shared';
import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { api } from './api';
import { INBOX_KEY } from './inbox';

export function useChatCapture(): UseMutationResult<
  ChatCaptureResponse,
  Error,
  ChatCaptureRequest
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (input) =>
      chatCaptureResponseSchema.parse(await api.post('/api/v1/chat/capture', input)),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: INBOX_KEY });
    },
  });
}

export function useChatVoiceCapture(): UseMutationResult<
  ChatVoiceCaptureResponse,
  Error,
  ChatVoiceCaptureRequest
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (input) =>
      chatVoiceCaptureResponseSchema.parse(await api.post('/api/v1/chat/capture/voice', input)),
    onSuccess: async (result) => {
      if (result.status === 'processed')
        await queryClient.invalidateQueries({ queryKey: INBOX_KEY });
    },
  });
}
